import initInstance from '@api/axios';
import authWithAzure from './azure';

const api = initInstance('/auth');

const AuthService = {
  links: {
    authWithAzure: authWithAzure(api),
    logout: () => api.getUri({ url: '/logout' }),
  },
  exchangeAzureAuthCode: (authCode: string, signal?: AbortSignal) => api.post(
    '/azure/exchange',
    { authCode },
    { signal },
  ),
};

export default AuthService;
